/* AUTEUR PDP, section index.

   The links are real hrefs rendered by Liquid, so the index works with no
   JavaScript at all: a native anchor jump lands correctly because the targets
   carry scroll-margin-top. This file adds the measured header offset, the
   offset-aware smooth scroll and the scrollspy on top of that.

   The scrollspy is throttled on a clock, not on requestAnimationFrame. rAF is
   suspended in a tab the browser is not painting, and a spy that silently stops
   updating is worse than none. Same reason the strata gate avoids rAF. */
(function () {
  'use strict';

  var VAR = '--apdp-nav-top';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var navs = document.querySelectorAll('[data-pdp-nav]');
    for (var i = 0; i < navs.length; i++) init(navs[i]);
  });

  function navTop() {
    var v = getComputedStyle(document.documentElement).getPropertyValue(VAR);
    return parseInt(v, 10) || 0;
  }

  function init(nav) {
    var scroller = nav.querySelector('[data-pdp-nav-scroll]');
    var wrap = nav.querySelector('[data-pdp-nav-wrap]');
    var links = Array.prototype.slice.call(nav.querySelectorAll('[data-target]'));
    if (!links.length) return;

    /* Measure the theme's own sticky header rather than assuming a number.
       Set on the root so both the sticky offset and the anchor scroll-margin
       read the same value. */
    function measureHeader() {
      var h = 0;
      var candidates = document.querySelectorAll('[id$="__header"], header');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        var cs = window.getComputedStyle(el);
        if (cs.position === 'sticky' || cs.position === 'fixed') {
          h = Math.max(h, Math.round(el.getBoundingClientRect().height));
        }
      }
      document.documentElement.style.setProperty(VAR, h + 'px');
      return h;
    }
    measureHeader();

    var targets = [];
    links.forEach(function (a) {
      var el = document.getElementById(a.getAttribute('data-target'));
      if (el) {
        el.classList.add('apdp-anchor-offset');
        targets.push({ link: a, el: el });
      } else {
        /* No matching section on this template. Do not leave a dead link. */
        a.setAttribute('hidden', '');
      }
    });
    if (!targets.length) { nav.setAttribute('hidden', ''); return; }

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function offset() {
      return nav.getBoundingClientRect().height + navTop();
    }

    targets.forEach(function (t) {
      t.link.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        var top = t.el.getBoundingClientRect().top + window.pageYOffset - offset() - 8;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
        if (history.replaceState) history.replaceState(null, '', '#' + t.el.id);
        t.el.setAttribute('tabindex', '-1');
        t.el.focus({ preventScroll: true });
      });
    });

    var last = 0, current = null;

    /* The lit item is the LAST section whose top has passed the line.
       Nothing is lit above the first section, which is correct: the hero and the
       claims strip are not in the index, so lighting an entry there would be a
       lie. An earlier version fell back to the last entry whenever nothing
       matched, which meant Questions lit up while you were still reading the
       first paragraph, and dragged the scroller to the far right with it. */
    function spy() {
      var now = +new Date();
      if (now - last < 100) return;
      last = now;

      var line = offset() + 12;
      var found = null;
      for (var i = 0; i < targets.length; i++) {
        if (targets[i].el.getBoundingClientRect().top - line <= 0) found = targets[i];
        else break;
      }
      if (found === current) return;
      current = found;
      targets.forEach(function (t) {
        t.link.setAttribute('aria-current', String(t === found));
      });
      if (found) keepVisible(found.link);
    }

    function keepVisible(link) {
      if (!scroller) return;
      if (scroller.scrollWidth - scroller.clientWidth < 4) return; /* nothing to scroll */
      var lr = link.getBoundingClientRect();
      var sr = scroller.getBoundingClientRect();
      if (lr.left < sr.left || lr.right > sr.right) {
        scroller.scrollTo({
          left: scroller.scrollLeft + (lr.left - sr.left) - 24,
          behavior: reduce ? 'auto' : 'smooth'
        });
      }
    }

    function cutHint() {
      if (!scroller || !wrap) return;
      var cut = scroller.scrollWidth - scroller.clientWidth > 4 &&
                scroller.scrollLeft + scroller.clientWidth < scroller.scrollWidth - 4;
      wrap.classList.toggle('is-cut', cut);
    }

    window.addEventListener('scroll', spy, true);
    window.addEventListener('resize', function () { measureHeader(); spy(); cutHint(); });
    if (scroller) scroller.addEventListener('scroll', cutHint);
    window.addEventListener('load', function () { measureHeader(); spy(); cutHint(); });
    [120, 600, 1500].forEach(function (t) { setTimeout(function () { spy(); cutHint(); }, t); });
    spy();
    cutHint();
  }
})();
